import { batch } from "@preact/signals-react"
import { companyUsers, dateRange } from "@signals"


export const clearSignals = () => batch(() => {
	companyUsers.value = []
	dateRange.value = []
})